import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {StoryCard} from "../story-card";
import {OverlayService} from "../../../overlay/overlay.service";
import {YoutubeVideoOverlayComponent} from "../../../shared/youtube-video-overlay/youtube-video-overlay.component";
import {CdColor} from "../../../enums/cd-color";
import {DomSanitizer} from "@angular/platform-browser";
import Player from "@vimeo/player";
import {StoryTheme} from "../story-theme";
import {DisplayService} from "../../../services/display.service";

@Component({
  selector: 'brt-video-card',
  templateUrl: './video-card.component.html',
  styleUrls: ['./video-card.component.scss']
})
export class VideoCardComponent implements AfterViewInit{

  @ViewChild("videoWrapper") videoWrapper = new ElementRef(null);
  @Input('card-data') set setCardData(val: StoryCard) {
    if(val.backgroundVideo) {
      if(val.backgroundVideo.src) {
        // console.log(val.backgroundVideo.src);
        if(val.backgroundVideo.src.includes("vimeo")) {
          if(val.backgroundVideo.src.indexOf("player.vimeo.com") === -1) {
            val.backgroundVideo.src = val.backgroundVideo.src.replace("vimeo.com", "player.vimeo.com");
          }
          const videoUrl = new URL(val.backgroundVideo.src);
          videoUrl.searchParams.set("autoplay", "1");
          videoUrl.searchParams.set("loop", "1");
          videoUrl.searchParams.set("muted", "1");
          videoUrl.searchParams.set("autopause", "0");
          // console.log(videoUrl.toString());
          // this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(videoUrl.toString());
          this.iframeSrc = val.backgroundVideo.src;
        }

      }
    }
    // console.log(val.embedVideo);
    this.cardData = val;
  };
  @ViewChild('mainEl') mainEl = new ElementRef(null);

  @Input('current') current = false;

  cardData!: StoryCard;
  iframeSrc: string = "";

  constructor(private overlayService: OverlayService, private sanitizer: DomSanitizer, private displayService: DisplayService) {
  }

  ngAfterViewInit() {
    if(this.videoWrapper && this.videoWrapper.nativeElement && this.iframeSrc.length) {
      const player = new Player(this.videoWrapper.nativeElement, {
        url: this.iframeSrc,
        controls: false,
        muted: true,
        autoplay: true,
        playsinline: true,
        loop: true,
        autopause: false
      })
    }
  }

  openVideo() {
    if(this.displayService.isMobileScreenSize()) {
      window.open(this.cardData.embedVideo?.src, "_blank");
    } else {
      this.overlayService.addComponent({component: YoutubeVideoOverlayComponent, data: {"youtube-str": this.cardData.embedVideo?.src}});
    }
  }

  onHover($event: MouseEvent) { // change to viewchild of video element
    const target = $event.target as HTMLElement;
    const tagName = target.tagName;
    // console.log(target.tagName);
    if(tagName === "video") {
      const videoEl = target as HTMLVideoElement;
      videoEl.volume = 0.0;
      videoEl.play();
    } else {
      if(this.mainEl.nativeElement) {
        const mainEl = this.mainEl.nativeElement as HTMLElement;
        const videoEl = mainEl.querySelector("video");
        // console.log(videoEl);
        if(videoEl) {
          const videoHTMLEl = videoEl as HTMLVideoElement;
          videoHTMLEl.volume = 0.0;
          videoHTMLEl.play();
        }
      }
    }
  }

  onUnHover($event: MouseEvent) {
    const target = $event.target as HTMLElement;
    const tagName = target.tagName;
    // console.log(target.tagName);
    if(tagName === "video") {
      const videoEl = target as HTMLVideoElement;
      videoEl.pause();
    } else {
      if(this.mainEl.nativeElement) {
        const mainEl = this.mainEl.nativeElement as HTMLElement;
        const videoEl = mainEl.querySelector("video");
        // console.log(videoEl);
        if(videoEl) {
          const videoHTMLEl = videoEl as HTMLVideoElement;
          videoHTMLEl.pause();
        }
      }
    }
  }

  protected readonly CdColor = CdColor;
  protected readonly StoryTheme = StoryTheme;
}
